import React from 'react'

const PagesIcon = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        d="M10 16.6667C9.33333 16.1389 8.61111 15.7292 7.83333 15.4375C7.05555 15.1458 6.25 15 5.41666 15C4.83333 15 4.26041 15.0764 3.69791 15.2292C3.13541 15.3819 2.59722 15.5972 2.08333 15.875C1.79166 16.0278 1.51041 16.0208 1.23958 15.8542C0.968745 15.6875 0.833328 15.4444 0.833328 15.125V5.08332C0.833328 4.93055 0.871523 4.78471 0.947912 4.64582C1.0243 4.50693 1.13888 4.40277 1.29166 4.33332C1.93055 3.99999 2.59722 3.74999 3.29166 3.58332C3.98611 3.41666 4.69444 3.33332 5.41666 3.33332C6.44444 3.33332 7.31944 3.45138 8.04166 3.68749C8.76388 3.9236 9.54166 4.28471 10.375 4.77082C10.5278 4.85416 10.6424 4.95138 10.7187 5.06249C10.7951 5.1736 10.8333 5.31943 10.8333 5.49999V14.2083C11.4444 13.9167 12.059 13.6979 12.6771 13.5521C13.2951 13.4062 13.9306 13.3333 14.5833 13.3333C15.0833 13.3333 15.5729 13.375 16.0521 13.4583C16.5312 13.5417 17.0139 13.6667 17.5 13.8333V3.81249C17.7083 3.88193 17.9132 3.95832 18.1146 4.04166C18.316 4.12499 18.5139 4.22221 18.7083 4.33332C18.8611 4.40277 18.9757 4.50693 19.0521 4.64582C19.1285 4.78471 19.1667 4.93055 19.1667 5.08332V15.125C19.1667 15.4444 19.0312 15.6875 18.7604 15.8542C18.4896 16.0208 18.2083 16.0278 17.9167 15.875C17.4028 15.5972 16.8646 15.3819 16.3021 15.2292C15.7396 15.0764 15.1667 15 14.5833 15C13.75 15 12.9444 15.1458 12.1667 15.4375C11.3889 15.7292 10.6667 16.1389 10 16.6667ZM12.9167 11.6667V2.49999L15.4167 1.66666V10.8333L12.9167 11.6667Z"
        fill="#FF5612"
      />
    </svg>

  )
}

export default PagesIcon